<template>
  <v-app>
    <v-img
      class="login-image"
    >
      <v-container
        class="fill-height"
        fluid
      >
        <v-app-bar
          flat
          color="transparent"
        >
          <v-list-item-avatar
            class="align-self-center"
            contain
          >
            <v-img
              src="favicon.png"
              max-height="100%"
            />
          </v-list-item-avatar>
          <v-toolbar-title class="text-h4">
            {{ $t('avatar') }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            text
            color="#fff"
            class="v-btn--active"
            href="/login"
          >
            <v-icon
              class="mr-1"
            >
              mdi-login
            </v-icon>
            Login
          </v-btn>
        </v-app-bar>
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title
                  :class="{ hidden: link_sent }"
                >
                  Password reset request
                </v-toolbar-title>
                <v-toolbar-title
                  :class="{ hidden: !link_sent }"
                >
                  Request sent
                </v-toolbar-title>
              </v-toolbar>
              <v-progress-linear
                color="success"
                :class="{hidden: !loading }"
                indeterminate
              />
              <v-card-text
                :class="{ hidden: link_sent }"
              >
                <v-text-field
                  ref="email"
                  v-model="email"
                  label="Email address"
                  prepend-icon="mdi-email"
                  type="text"
                  :rules="[
                    v => !!v || 'This is required'
                  ]"
                  @keydown.enter.prevent="ForgotPassword"
                />
              </v-card-text>
              <div
                class="px-12 text-body-1 error--text"
                :class="{ hidden: !error }"
              >
                An error has occurred!
              </div>
              <div
                class="px-12 text-body-1 primary--text mt-4"
                :class="{ hidden: !link_sent }"
              >
                Request has been sent!
              </div>
              <v-card-actions>
                <v-col>
                  <v-row class="px-3">
                    <v-spacer />
                    <v-btn
                      text
                      color="primary"
                      class="v-btn--active"
                      :class="{ hidden: link_sent }"
                      :disabled="loading"
                      @click="ForgotPassword"
                    >
                      Send Reset Password Link
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      class="v-btn--active"
                      :class="{ hidden: !link_sent }"
                      href="https://outlook.office.com/mail/inbox"
                    >
                      Check your Inbox
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
              <br>
            </v-card>
          </v-col>
        </v-row>
        <v-row
          align="center"
          no-gutters
        >
          <v-spacer class="hidden-sm-and-down" />
          <v-col
            cols="12"
            md="auto"
            class="mr-6"
          >
            <div class="footer text-center">
              Copyright &copy; 2021 - <a href="/">McDonald's Philippines</a>.
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-img>
  </v-app>
</template>
<style scoped>
  .footer, .footer a, .text-h4 {
    color: #fff !important;
    font-weight: 400 !important;
  }
</style>
<script>
  import { ForgotPassword } from '@/graphql/Auth.gql'
  export default {
    data () {
      return {
        link_sent: false,
        email: '',
        loading: false,
        error: false,
        // rebuild
      }
    },
    mounted () {
      this.$refs.email.focus()
    },
    methods: {
      ForgotPassword () {
        if (this.email === '') { return }
        if (this.loading) { return }
        this.loading = true
        this.error = false
        this.link_sent = false
        this.$apollo.mutate({
          mutation: ForgotPassword,
          variables: {
            input: {
              email: this.email,
            },
          },
        }).then(() => {
          this.loading = false
          this.link_sent = true
        }).catch(error => {
          this.loading = false
          this.error = (error)
        })
      },
    },
  }
</script>
